/*
 * Módulo de frontend: página "Observabilidad" (dashboards de Grafana embebidos).
 * Standalone (no depende del catálogo): lista dashboards vía el proxy de Grafana y
 * embebe el seleccionado a pantalla completa.
 */
import {
  PageBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import DashboardIcon from '@material-ui/icons/Dashboard';

const observabilityPage = PageBlueprint.make({
  name: 'observability',
  params: {
    path: '/observabilidad',
    title: 'Observabilidad',
    icon: <DashboardIcon />,
    loader: () =>
      import('./ObservabilityPage').then(m => <m.ObservabilityPage />),
  },
});

export const observabilityModule = createFrontendModule({
  pluginId: 'app',
  extensions: [observabilityPage],
});
